import React, { useEffect, useState } from 'react';
import ModalFullscreenActions from "../flux/ModalFullscreenActions";
import styled from "styled-components";
import __ from "../utils/translator";
import TagStore from "../flux/TagStore";
import Button from "../components/Button";
import GlossaryFilterStore from "../flux/GlossaryFilterStore";
import GlossaryStoreActions from "../flux/GlossaryStoreActions";
import Header from '../components/organisms/Header';
import { Link } from 'react-router-dom';

const SORT_OPTION_ALPHABETICAL = 'alphabetical';
const SORT_OPTION_NEWEST = 'newest';

const sortOptions = [
  { name: SORT_OPTION_ALPHABETICAL, value: __('Alphabetical') },
  { name: SORT_OPTION_NEWEST, value: __('Newest') },
];

const GlossaryFilter = (props) => {
  const filter = GlossaryFilterStore.getState();
  const [tags, setTags] = useState(TagStore.getState())
  const [currentSortOption, setCurrentSortOption] = useState(filter.currentSortOption);
  const [currentFilterTagList, setCurrentFilterTagList] = useState(filter.currentFilterTagList);

  useEffect(function () {
    ModalFullscreenActions.toggleFilterIcon(false);
  }, []);

  useEffect(function () {
    const subscription = TagStore.addListener(() => {
      setTags(TagStore.getState());
    })

    return function () {
      subscription.remove();
    }
  }, []);

  const handleOnTagClick = (id) => {
    let nextCurrentFilterTagList = [...currentFilterTagList];
    let pos = nextCurrentFilterTagList.indexOf(id);
    //remove tag from list
    if (pos >= 0) {
      nextCurrentFilterTagList.splice(pos, 1);
    } else {
      nextCurrentFilterTagList.push(id)
    }
    setCurrentFilterTagList(nextCurrentFilterTagList);
  }

  const handleApplyFilter = () => {
    GlossaryStoreActions.updateFilter({
      currentSortOption,
      currentFilterTagList
    });
  }

  return (
    <React.Fragment>
      <Header actions={['back']} />

      <Container>
        <FilterSection>
          <h3>{__('Sort by')}</h3>
          {sortOptions.map((sortType, index) => (
            <Filter key={index}
              selected={currentSortOption === sortType.name}
              onClick={() => setCurrentSortOption(sortType.name)}
            >
              {__(sortType.value)}
            </Filter>
          ))}

          <h3 style={{ marginTop: '1rem' }}>{__('Filter by')}</h3>
          {tags.map(tag => (
            <Filter key={tag.id}
              selected={currentFilterTagList.indexOf(tag.id) >= 0}
              onClick={() => handleOnTagClick(tag.id)}>
              {__(tag.name.toLowerCase())}
            </Filter>
          ))}
        </FilterSection>

        <Link to="/">
          <Button
            size="large"
            style={{ width: '100%', backgroundColor: '#000', color: '#fff' }}
            type="submit"
            onClick={handleApplyFilter}
          >
            {__('Apply')}
          </Button>
        </Link>
      </Container>
    </React.Fragment>
  );
};

export default GlossaryFilter;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: .625rem 1.25rem 1.25rem;
`;

const FilterSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -.625rem 2rem -.625rem;

  h3 {
    margin: .5rem;
    width: 100%;
    text-transform: uppercase;
  }
`;

const Filter = styled.span`
  color: ${props => props.selected ? '#fff' : '#000'};
  background-color: ${props => props.selected ? '#000' : '#fff'};
  border: 1px solid #000;
  padding: .5rem;
  margin: .5rem;
  text-transform: capitalize;
`;
